import axiosInstance from "api/axiosInstance";

import type { SearchParams, SearchResponse } from "api/types/search.types";

const BASE = "/server/buccl_main/api/v1/search/";

export const searchService = {
  // 통합 검색 (강습/투어/제품). type 미지정 시 백엔드 기본값 all
  search: (params: SearchParams) => axiosInstance.get<SearchResponse>(BASE, { params }),
};
